<template>
  <transition name="fade">
    <div class="toaster">
      <p class="toaster__title">{{ title || "Error" }}</p>
      <p class="toaster__text">{{ errorMessage }}</p>
    </div>
  </transition>
</template>

<script>
export default {
  name: "Toaster",
  props: {
    title: String,
    errorMessage: String
  },
  mounted() {
    this.initClosingSequence();
  },
  methods: {
    initClosingSequence() {
      setTimeout(() => this.$modal.hide("Toaster"), 5000);
    }
  }
};
</script>

<style lang="scss">
.v--modal-overlay[data-modal="Toaster"] {
  background: transparent;

  .fade-enter-active,
  .fade-leave-active {
    transition: all 1s ease-in;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}

.toaster {
  margin: 50px;
  text-align: center;
  font-stretch: normal;
  font-style: normal;
  letter-spacing: normal;
  color: $group-3-color-2;

  &__title {
    margin: 0px 0px 30px 0px;
    font-size: 24px;
    font-weight: bold;
    line-height: normal;
  }

  &__text {
    margin: 0px;
    font-size: 16px;
    font-weight: normal;
    line-height: 22px;
  }
}
</style>
